export default function CtaBanner() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20atmospheric%20product%20composition%20with%20premium%20sneakers%20a%20leather%20tote%20bag%20and%20folded%20garments%20artfully%20arranged%20in%20a%20gentle%20arc%20on%20a%20textured%20linen%20surface%2C%20diffused%20window%20light%20creating%20a%20dreamy%20glow%2C%20muted%20pastel%20tones%20of%20sage%20blush%20and%20sand%2C%20airy%20ethereal%20editorial%20photography%20with%20negative%20space%20for%20text%20overlay%2C%20calm%20sophisticated%20aesthetic&width=1800&height=600&seq=cta-banner-bg-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-cream-50/90 via-cream-50/70 to-cream-50/90"></div>
      </div>

      <div className="relative z-10 px-6 md:px-10 max-w-3xl mx-auto text-center">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-warm-950">
          Accedi all&apos;<span className="text-tealwarm-600">Itaobuy Spreadsheet</span> aggiornato
        </h2>
        <p className="mt-4 text-sm md:text-base text-warm-600 max-w-lg mx-auto">
          Non perdere altro tempo nella ricerca manuale. Esplora subito lo spreadsheet con tutte le categorie aggiornate, foto QC e link diretti ai prodotti selezionati.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-warm-900 text-white text-base font-semibold hover:bg-warm-800 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-warm-600 text-white text-base font-semibold hover:bg-warm-700 transition-all whitespace-nowrap cursor-pointer"
          >
            Itaobuy Sheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <div className="mt-8 flex items-center justify-center gap-6 flex-wrap">
          <span className="inline-flex items-center gap-1.5 text-xs text-warm-500">
            <i className="ri-shield-check-line text-tealwarm-600"></i> Link verificati
          </span>
          <span className="inline-flex items-center gap-1.5 text-xs text-warm-500">
            <i className="ri-refresh-line text-tealwarm-600"></i> Aggiornato 2026
          </span>
          <span className="inline-flex items-center gap-1.5 text-xs text-warm-500">
            <i className="ri-global-line text-tealwarm-600"></i> Guida in italiano
          </span>
        </div>
      </div>
    </section>
  );
}